module.exports = __webpack_public_path__ + "media/images/emblems/Airolo-coat_of_arms-4981481fb313bf8671cdbd1b192b6ab8.svg";